'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _ShopCard = require('./ShopCard');

var _ShopCard2 = _interopRequireDefault(_ShopCard);

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _lib = require('helpers/lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_BOX_NUMBER = 8;
var HomeServiceShopHorizontalList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shops: state.shops.homeService,
    province: state.address.province,
    categories: state.setup.categories,
    homeServiceLoading: state.shops.homeServiceLoading,
    homeServiceLoaded: state.shops.homeServiceLoaded
  };
}, (0, _extends3.default)({}, shopActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(HomeServiceShopHorizontalList, _Component);

  function HomeServiceShopHorizontalList() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, HomeServiceShopHorizontalList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = HomeServiceShopHorizontalList.__proto__ || (0, _getPrototypeOf2.default)(HomeServiceShopHorizontalList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      firstLoad: false,
      category: []
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(HomeServiceShopHorizontalList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.homeServiceLoaded && this.props.homeServiceLoading !== true || !this.props.shops || !this.state.firstLoad) {
        this.getResult.call(this);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.homeServiceLoading) {
        this.setState({ firstLoad: true });
      }
      if (nextProps.province !== this.props.province) {
        this.getResult.call(this, nextProps.province);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult(province) {
      var filter = {
        category: this.state.category.join(','),
        province: province ? province : this.props.province,
        pageSize: this.props.boxNumber || DEFAULT_BOX_NUMBER
      };
      this.props.getHomeService(filter, true);
    }
  }, {
    key: 'isActiveCategory',
    value: function isActiveCategory(cat) {
      return this.state.category.length === 0 || this.state.category.indexOf(cat) !== -1;
    }
  }, {
    key: 'activeCategory',
    value: function activeCategory(cat) {
      var category = [cat];
      if (this.state.category.indexOf(cat) !== -1) {
        category = [];
      }
      this.setState({ category: category });
      this.props.getHomeService({
        category: category.join(','),
        province: this.props.province,
        pageSize: this.props.boxNumber || DEFAULT_BOX_NUMBER
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          shops = _props.shops,
          boxNumber = _props.boxNumber;
      var category = this.state.category;

      var styles = require('./Box.scss');
      var cards = [];
      if (shops && shops.length > 0) {
        var length = shops.length > boxNumber ? boxNumber : shops.length;
        for (var index = 0; index < length; index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3', key: String(index) },
            _react2.default.createElement(_ShopCard2.default, { shop: shops[index] })
          ));
        }
      } else {
        for (var _index = 0; _index < (boxNumber || DEFAULT_BOX_NUMBER); _index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-3', key: String(_index) },
            _react2.default.createElement(_ShopCard2.default, null)
          ));
        }
      }
      if (!shops || !shops.length) return null;
      return _react2.default.createElement(
        'div',
        { className: styles.box },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.left },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: '/dich-vu-tai-nha' + (category.length > 0 ? '&category=' + (0, _lib.code2textCat)(category, this.props.categories).join(',') : '')
              },
              _react2.default.createElement(
                'h2',
                { className: styles.title },
                'L\xE0m \u0110\u1EB9p T\u1EA1i Nh\xE0'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.category },
              _react2.default.createElement('div', {
                className: styles.catSpa + (this.isActiveCategory('01') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('01');
                },
                title: 'Ch\u0103m S\xF3c Da/Massage'
              }),
              _react2.default.createElement('div', {
                className: styles.catHair + (this.isActiveCategory('02') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('02');
                },
                title: 'L\xE0m T\xF3c/M\xF3ng'
              }),
              _react2.default.createElement('div', {
                className: styles.catHomeService + (this.isActiveCategory('07') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('07');
                },
                title: 'L\xE0m \u0110\u1EB9p T\u1EA1i Nh\xE0'
              }),
              _react2.default.createElement('div', {
                className: styles.catClinic + (this.isActiveCategory('04') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('04');
                },
                title: 'Ph\xF2ng Kh\xE1m'
              }),
              _react2.default.createElement('div', {
                className: styles.catFitness + (this.isActiveCategory('05') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('05');
                },
                title: 'Th\u1EC3 D\u1EE5c Th\u1EC3 Thao'
              }),
              _react2.default.createElement('div', {
                className: styles.catCosmetic + (this.isActiveCategory('03') ? ' ' + styles.active : ''),
                onClick: function onClick() {
                  return _this2.activeCategory('03');
                },
                title: 'Th\u1EA9m M\u1EF9 Vi\u1EC7n'
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.right },
            _react2.default.createElement(
              _reactRouter.Link,
              {
                to: '/dich-vu-tai-nha' + (category.length > 0 ? '&category=' + (0, _lib.code2textCat)(category, this.props.categories).join(',') : '')
              },
              _react2.default.createElement(
                'div',
                { className: styles.seeMore },
                'Xem th\xEAm',
                _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
                  className: styles.arrowRight,
                  glyph: 'menu-right'
                }, 'className', styles.arrowRight))
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bodyBox + ' row' },
          cards
        )
      );
    }
  }]);
  return HomeServiceShopHorizontalList;
}(_react.Component), _class2.propTypes = {
  shops: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  getHomeService: _react.PropTypes.func.isRequired,
  province: _react.PropTypes.string,
  homeServiceLoaded: _react.PropTypes.bool,
  homeServiceLoading: _react.PropTypes.bool,
  boxNumber: _react.PropTypes.number
}, _temp2)) || _class);
exports.default = HomeServiceShopHorizontalList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Box/HomeServiceShopHorizontalList.js
// module id = 1511
// module chunks = 0